<script lang="ts">
	import PageGrid from '../components/pageGrid.svelte';
	import Carousel from '$lib/carousel.svelte';
	import type { EmblaCarouselType } from 'embla-carousel';
	import CarouselNavigationArrows from '$lib/carouselNavigationArrows.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import { device } from '$lib/state/device.svelte';

	interface Props {
		content: ISbStoryData<{
			title: string;
			quotes: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();

	let embla = $state<EmblaCarouselType>();
	let active = $state(0);

	function next() {
		if (embla) {
			embla.scrollNext();
		}
	}

	function previous() {
		if (embla) {
			embla.scrollPrev();
		}
	}
</script>

<section use:editable={content} class="relative w-screen overflow-x-hidden">
	<PageGrid>
		<div
			class="col-span-full flex justify-between gap-x-10"
			class:flex-col={!device.data.isDesktop || content.quotes.length > 2}
		>
			{#if content.title}
				<h1
					class="mb-20 text-center font-serif text-[32px]/[110%] tracking-[-.32px] text-green-3 lg:mb-16 lg:text-[48px]/[110%] lg:tracking-[-.48px]"
					class:lg:text-start={content.quotes.length <= 2}
					class:lg:max-w-[360px]={content.quotes.length <= 2}
				>
					{content.title}
				</h1>
			{/if}

			{#if content.quotes.length < 4 && device.data.isDesktop}
				<div
					class="flex justify-around gap-x-15"
					class:mt-20={content.quotes.length > 2}
					class:lg:mt-16={content.quotes.length > 2}
				>
					{#each content.quotes as quote}
						<div class="max-w-[338px]">
							<Blok content={quote} />
						</div>
					{/each}
				</div>
			{:else}
				<Carousel
					bind:embla
					bind:currentIndex={active}
					align="start"
					overflow
					class="flex gap-x-15"
				>
					{#each content.quotes as quote}
						<div class="flex-none basis-[69%] sm:basis-[40%] lg:basis-[25%]">
							<Blok content={quote} />
						</div>
					{/each}
				</Carousel>
				<div class="my-16 flex justify-center max-lg:hidden">
					<CarouselNavigationArrows
						hasNext={active < content.quotes.length - 3}
						hasPrev={active !== 0}
						onnext={next}
						onprevious={previous}
					/>
				</div>
			{/if}
		</div>
	</PageGrid>
	<div class="right-fade absolute inset-y-10 -right-8 w-36 max-lg:hidden"></div>
	<div class="right-fade absolute inset-y-10 -left-8 w-36 rotate-180 max-lg:hidden"></div>
</section>

<style>
	.right-fade {
		background: linear-gradient(90deg, rgba(248, 244, 235, 0) 0%, rgba(248, 244, 235, 0.8) 100%);
	}
</style>
